import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/Finance/Hero";
import IndustriesContent from "../components/Finance/IndustriesContent";
import PageTitle from "../components/Finance/PageTitle";

import '../assets/Webdevelopment.css';



const Finance = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<IndustriesContent />
	  	</div>
	)
}

export default Finance;
